import React from 'react';

const Interactions: React.FC = () => {
  return <div className="card"><h1>Hvem har du delt måltider med</h1><p>TODO: Show interactions</p></div>;
};

export default Interactions;
